import mem from "mem";

import {
  sendMessageToReactNativeWebView,
  WEB_VIEW_ACTIONS,
} from "@/shared/lib";
import type { ServiceResponse } from "@/shared/lib/axios";
import { privateAPI } from "@/shared/lib/axios";
import { authStore } from "@/shared/stores";

interface UserToken {
  refreshToken: string;
  tokenType: string;
  expiresIn: number;
}

const refreshToken = async () => {
  let refreshWasSuccessful = false;

  try {
    const response =
      await privateAPI.post<ServiceResponse<UserToken>>("/auth/refresh");

    const { data: userToken } = response.data;
    if (!userToken.refreshToken) {
      sendMessageToReactNativeWebView({ type: WEB_VIEW_ACTIONS.LOGOUT });
      authStore.setToken(null);
    } else {
      refreshWasSuccessful = true;
      authStore.setToken(userToken.refreshToken);
    }
  } catch {
    sendMessageToReactNativeWebView({ type: WEB_VIEW_ACTIONS.LOGOUT });
    authStore.setToken(null);
  }

  return refreshWasSuccessful;
};

const MAX_AGE = 10000;

export const memoizedRefreshToken = mem(refreshToken, { maxAge: MAX_AGE });
